import imagePlaceholder from "assets/imgs/imagePlaceholder.png";

export const DEFAULT_CATEGORY_CONFIG = {
  image: imagePlaceholder,
  accentColor: "#009fe4",
};
